export default "__VITE_ASSET__B_m1c0hv__"